import React from 'react'
import { ImCheckmark2 } from "react-icons/im";

export const ClinicStatus = () => {
    return (
        <div className='bg-white rounded-lg h-full mt-10 pt-16 px-10 flex flex-col items-center gap-36 w-full shadow-lg'>
            <h2 className='font-semibold italic text-lg'>The clinic is Currently Verified and Active on the Platform and appears as
            </h2>
            <div className='w-fit flex flex-col gap-2 justify-center items-center'>
                <div className='rounded-full border-dashed border-blue-500 border-2 p-7 w-fit'>
                    <div className='rounded-full bg-[#daeeff] p-4'>
                        <ImCheckmark2 className='text-green-500 text-5xl' />
                    </div>
                </div>
                <h2 className='font-bold text-3xl'>C4C Name</h2>
            </div>
            <div className='w-full flex justify-around items-center '>
                <button className='bg-yellow-500 w-fit text-white py-2 px-5 rounded-lg '>Deactivate</button>
                <button className='bg-green-500 w-fit text-white py-2 px-5 rounded-lg '>Edit Instead</button>
            </div>
        </div>
    )
}
